import { z } from "zod";

export const userQuotaCycleModeSchema = z.enum([
  "organization_month",
  "custom_duration",
]);

export const userQuotaStatusSchema = z.object({
  referenceStartsAt: z.string(),
  periodEndsAt: z.string(),
  cycleMode: userQuotaCycleModeSchema,
  maxUsage: z.number(),
  usageUsed: z.number(),
});

export const quotaLimitDetailsSchema = z.object({
  referenceStartsAt: z.string(),
  periodEndsAt: z.string(),
  cycleMode: userQuotaCycleModeSchema,
  maxUsage: z.number(),
  usageUsed: z.number(),
  maxConcurrent: z.number().optional(),
  inProgressCount: z.number().optional(),
});

export type UserQuotaStatus = z.infer<typeof userQuotaStatusSchema>;
export type QuotaLimitDetails = z.infer<typeof quotaLimitDetailsSchema>;
